import React, {Component} from "react"

import History from "@irati/utils/history"
import Loader from "@irati/ui/src/Loading/Loader"
import session from "@irati/auth/services/session"
import internalTracking from "@irati-tracking/internal"
import ghostLoginService from "@irati/auth/services/ghostUserLogin"
import loginService from "@irati/auth/services/login"
import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"

interface Props {}

/** @description: This component can load twice, sometimes by changing language.
 * Running it twice can cause issues so block it.
 */
let hasRun = false

class Ghost extends Component<Props> {
  async componentDidMount() {
    if (!hasRun) {
      hasRun = true
      try {
        await this.login()
      } catch (e) {
        this.failed(e)
      }
    }
  }

  login = async() => {
    await loginService.logout({redirectOnLogout: false})
    const {accessToken} = await session.getThenRemove(["accessToken"])
    if (!accessToken) {
      throw new Error("Missing data")
    }
    await ghostLoginService.login(accessToken)
    await this.showUserWarning()
    internalTracking.ghostLogin()
    return History.push({pathname: "/"})
  }

  showUserWarning = async() => {
    const user = authentication.user()
    const confirmed = confirm(`You are ghosting as '${firstnameLastname(user)}', anything you do will appear as if they did it. Continue?`)
    if (!confirmed) {
      window.close()
    }
  }

  failed = (error: string) => {
    console.warn("ghost user login errored", error)
    History.push({
      pathname: "/"
    })
  }

  render() {
    return (
      <div>
        <h1 className="center">Loading ghost user...</h1>
        <Loader />
      </div>
    )
  }
}

export default Ghost
